<template>

<div>
  <section class="lp_top_image">
      <img src="@/assets/img/tmf2026/tmf_top.jpg" />
  </section>
  <section>
    <div class="lp_button_list">
      <div class="box-p-20 text-center">
        <a href="https://youtu.be/1ieZYST0UyM" target="_blank" class="d-inline-block">
          <img src="@/assets/img/tmf2026/tmf2026_president.jpg">
        </a>
      </div>
      <div class="box-p-20 text-center">
        <router-link to="/lp/tmf2026_speech" class="d-inline-block">
          <img src="@/assets/img/tmf2026/tmf2026_speech.jpg">
        </router-link>
      </div>
      <div class="box-p-20 text-center">
        <router-link to="/lp/tmf2026_album" class="d-inline-block">
          <img src="@/assets/img/tmf2026/tmf2026_album.jpg">
        </router-link>
      </div>
      <div class="box-p-20 text-center">
        <a href="https://youtu.be/gL-Zd7lWEG8" target="_blank" class="d-inline-block">
          <img src="@/assets/img/tmf2026/tmf2026_first.jpg">
        </a>
      </div>
      <div class="box-p-20 text-center">
        <a href="https://youtu.be/RvsdVW8yOKo" target="_blank" class="d-inline-block">
          <img src="@/assets/img/tmf2026/tmf2026_second.jpg">
        </a>
      </div>
    </div>

    <div class="box-p-20 text-center">
      <router-link to="/dashboard" class="btn d-inline-block">
        会員サイトトップに戻る
      </router-link>
    </div>
  </section>
</div>
</template>

<style scoped>
.font-bold {
  font-weight: bold;
}

.lp_top_image {
  margin-bottom: 50px;
}

/* PC・タブレット：常に3列 */
.lp_button_list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  width: 100%;
}

/* 各ボタンの配置枠 */
.lp_button_list > .box-p-20 {
  min-width: 0;
  box-sizing: border-box;
}

/* ボタン本体 */
.lp_button_list .btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 260px;
  min-height: 70px;
  box-sizing: border-box;
}

/* タブレット */
@media screen and (max-width: 1200px) {
  .lp_button_list {
    gap: 15px;
  }

  .lp_button_list > .box-p-20 {
    padding-left: 5px;
    padding-right: 5px;
  }
}

/* スマートフォン */
@media screen and (max-width: 767px) {

  .lp_button_list {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  /* 2つ目のボタンリストとの余白 */
  .lp_button_list + .lp_button_list {
    margin-top: 15px;
  }

  .lp_button_list > .box-p-20 {
    width: 100%;
    padding: 0;
    min-width: 0;
    box-sizing: border-box;
  }

  .lp_button_list .btn {
    width: 100%;
    max-width: none;
    min-height: 64px;
  }
}
</style>

<script>
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 100; i++) {
        this.isActive[i] = false
    }
  },
  methods: {
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = !this.isActive[ref]
      console.log(this.isActive[ref])
    },
  }
}
</script>